var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 41,
    viewBox: "0 0 54 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.601 6.3903C53.4543 7.14642 53.5039 8.46181 52.7099 9.28001L22.7695 40.1338C22.0052 40.9215 20.7488 40.946 19.9543 40.1886L1.57507 22.6687C0.727493 21.8607 0.752243 20.5007 1.62866 19.7241L7.36896 14.6378C8.16062 13.9363 9.36161 13.9725 10.1095 14.7205L19.9172 24.5281C20.7204 25.3313 22.0305 25.3051 22.801 24.4704L44.0599 1.44C44.7983 0.640016 46.041 0.577638 46.8558 1.29966L52.601 6.3903Z",
    fill: "#519D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenright);
export default __webpack_public_path__ + "static/media/greenright.719747043f3d679b2cf3b96b27517db9.svg";
export { ForwardRef as ReactComponent };